import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTreeModule } from '@angular/material/tree';
import { DepNivDiscNode } from '@app/models/enseignant';
import { SharedModule } from '@app/modules/shared.module';

@Component({
  selector: 'app-department-tree',
  imports: [MatTreeModule, MatIconModule, MatButtonModule, SharedModule],
  templateUrl: './department-tree.component.html',
  styleUrl: './department-tree.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepartmentTreeComponent {
  nodes = input.required<DepNivDiscNode[]>();

  childrenAccessor = (node: DepNivDiscNode) => node.children ?? [];
  hasChild = (_: number, node: DepNivDiscNode) => !!node.children?.length;

  stats = computed(() => {
    let disciplines = 0, niveaux = 0;
    for (const dept of this.nodes()) {
      disciplines += dept.children?.length ?? 0;
      for (const disc of dept.children ?? []) {
        niveaux += disc.children?.length ?? 0;
      }
    }
    return { depts: this.nodes().length, disciplines, niveaux };
  });
}
